import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { useRanger } from "@tanstack/react-ranger";
import { Caption, Mark, Segment, SliderWrapper, Thumb, ThumbLabel, getIteratorObject, isNumberInRange, timeToSeconds, toHHMM } from "../components";
const DateRangeSelectionSlider = ({ onChange, initialValues, hasInput, hasMarks }) => {
    const min = 0;
    const max = 86399;
    const marksObject = getIteratorObject(max, min, false, [0, 43200, 86399]);
    const rangerRef = React.useRef(null);
    const [values, setValues] = React.useState(initialValues.map((timeValue) => timeToSeconds(timeValue)));
    useEffect(() => {
        setValues(initialValues.map((timeValue) => timeToSeconds(timeValue)));
    }, [initialValues]);
    const handleChange = (instance) => {
        onChange(instance.sortedValues.map((value) => toHHMM(value)));
        setValues(instance.sortedValues);
    };
    const handleDrag = (instance) => {
        onChange(instance.sortedValues.map((value) => toHHMM(value)));
        setValues(instance.sortedValues);
    };
    const rangerInstance = useRanger({
        getRangerElement: () => rangerRef.current,
        values,
        min,
        max,
        stepSize: 60,
        onChange: handleChange,
        onDrag: handleDrag,
    });
    return (_jsx(SliderWrapper, { children: _jsxs("div", { ref: rangerRef, className: "relative h-1 w-full rounded-full bg-gray-4", children: [hasMarks &&
                    marksObject?.map(({ value, key, percentage }) => (_jsx(Mark, { percentage: percentage, isActive: isNumberInRange(percentage, values.map(rangerInstance.getPercentageForValue)), children: _jsx(Caption, { percentage: percentage, children: toHHMM(value) }) }, key))), rangerInstance.getSteps().map(({ left, width }, index) => index === 1 && _jsx(Segment, { left: left, width: width }, left)), rangerInstance.handles().map(({ value, onKeyDownHandler, onMouseDownHandler, onTouchStart, isActive }) => (_jsxs("div", { children: [_jsx(Thumb, { value: value, onKeyDownHandler: onKeyDownHandler, onMouseDownHandler: onMouseDownHandler, onTouchStart: onTouchStart, min: rangerInstance.options.min, max: rangerInstance.options.max, isActive: isActive, percentageForValue: rangerInstance.getPercentageForValue(value) }, `value-${value}-${isActive}`), _jsx(ThumbLabel, { value: toHHMM(value), percentageForValue: rangerInstance.getPercentageForValue(value) })] }, value)))] }) }));
};
export default DateRangeSelectionSlider;
